import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validator,
} from '@angular/forms';

@Component({
  selector: 'gatewee-radio-button',
  templateUrl: './gatewee-radio.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GateweeRadioComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => GateweeRadioComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class GateweeRadioComponent
  implements ControlValueAccessor, Validator, OnInit
{
  private static nextId = 0;

  @Input() label = '';
  @Input() name = `gatewee-radio-${GateweeRadioComponent.nextId++}`;
  @Input() value!: string | boolean;
  @Input() caption = '';
  @Input() readonly = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _value: any = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  control = new FormControl(this.value);

  ngOnInit(): void {
    // Update control when parent value changes
    this.control.setValue(this._value, {emitEvent: false});

    this.control.valueChanges.subscribe(selectedValue => {
      if (!this.readonly && selectedValue === this.value) {
        this._value = this.value;
        this.onChange(this.value);
        this.onTouched();
      }
    });
  }

  get isChecked(): boolean {
    return this._value === this.value;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  writeValue(value: any): void {
    this._value = value;
    // Set control to this.value if it matches, or null if not
    this.control.setValue(this.isChecked ? this.value : null, {
      emitEvent: false,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.readonly = isDisabled;
    if (isDisabled) {
      this.control.disable({emitEvent: false});
    } else {
      this.control.enable({emitEvent: false});
    }
  }

  validate() {
    return null;
  }

  onInputChange(): void {
    // Handled by control.valueChanges subscription
  }
}
